// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"f5eeebce","453":"6ae026fe","455":"91dffb45","867":"2c475139"}[chunkId] + ".chunk.js";
};